import persistReducer from 'redux-persist/es/persistReducer'
import sessionStorage from 'redux-persist/lib/storage/session'
import sessionSlice from '../slices/session.slice'
import { REDUX_PERSIST_CONSTANTS } from '../utils/constants'
import { resetTransientSessionTransform } from '../utils/resetTransientSessionTransform'
import { dropTokensForMsBackendTransform } from '../utils/dropTokensForMsBackendTransform'

/**
 * Session timers — sessionStorage only (per-tab).
 *
 * Under the hardened MS_BACKEND flow the access token, refresh token and expiry
 * are NOT persisted: they are held in memory only, so they vanish on reload and
 * a script can't read them out of storage. On the next load the boot saga
 * re-fetches the access token from the HttpOnly session cookie via
 * `/session-token`.
 *
 * That rule is applied by `dropTokensForMsBackendTransform` and NOT by a flat
 * `blacklist`, because this config governs the one `session` slice that all
 * three providers share. A flat blacklist also stripped the tokens for COGNITO
 * and MSAL, which have no equivalent boot-time recovery — a reload left them
 * rendering with no bearer (gateway 403 on every call) and, for COGNITO, with
 * the refresh token its 403/409 recovery branch depends on also gone. See that
 * transform for the full account.
 *
 * Transient auth-check flags are reset on rehydration (see transform).
 */
export const sessionPersistConfig = {
  key: REDUX_PERSIST_CONSTANTS.SESSION,
  storage: sessionStorage,
  transforms: [resetTransientSessionTransform, dropTokensForMsBackendTransform],
}

export const persistedSessionReducer = persistReducer(
  sessionPersistConfig,
  sessionSlice
)

/** redux-persist key in sessionStorage for the session slice; remove on full logout if needed. */
export const SESSION_SLICE_SESSION_STORAGE_KEY = `persist:${REDUX_PERSIST_CONSTANTS.SESSION}`
